import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class LyftDispatchReceiptLineItem extends AbstractModel {
  @autoserialize
  lyftDispatchRideReceiptId: number;

  @autoserialize
  currency: string;

  @autoserialize
  amount: number;

  @autoserialize
  type: string;
}
